import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');


const RenderSadfinderLight = () => {
const awcurl=sessionStorage.getItem("AWC_URL");
const awsurl=sessionStorage.getItem("AWS_URL");
const resturl=sessionStorage.getItem("REST_URL");

let emptySadfinder={};
var emptyselectedsad;
let arrCTY_COD=[], arrCTY_NAM=[]
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [boolFetchingSads, setBoolFetchingSads] = useState({
	flag:false
});


const [selectedCtry, setSelectedCtry] = useState({
COD:''
, NAM:''
});
const [ctryCod, setCtryCod] = useState([]);
const [ctryNam, setCtryNam] = useState([]);
const [hiddenCtyInputs, setHiddenCtyInputs] = useState([]);


const [tblsadfinder, setTblsadfinder] = useState([]);
const [exitnoteitemrows, setExitnoteitemrows] = useState([]);

const [islandOptions, setIslandOptions] = useState([]);
const [statusOptions, setStatusOptions] = useState([]);
const [trashedOptions, settrashedOptions] = useState([]);
const [pastmonthsOptions, setPastmonthsOptions] = useState([]);
const [tbldetails, setTbldetails] = useState([]);

const [transkey, setTranskey] = useState({
seqno:0
,LOCK_INFO:''
});


const [sad, setSad] = useState({
	INSTANCEID:null
	,STR_SHD_NAM:null
	,STR_OFFICE:null
	,STR_REG_NBR:null
	,STR_DEC_NAM:null
	,IDE_CUO_COD:null
	,AST_RYR:null
	,SHORT_STATUS:null
	,PTY_COL_DSC:null
	,STATUS_COLOR:null
	,DEC_REP:null
	,STR_AMT_DTY:null
	,STR_REG_DAT:null
	,STR_CMP_NAM:null
	,STR_DEC_NAM:null
	,CTR_COUNT:null
	,PTY_NBR_ITM:null
	,FIN_ACC:null
	,TPT_LOC:null
	,EXT_INSTANCE_ID:null
});

const [selectedsad, setSelectedsad] = useState({
	INSTANCEID:null
});

const [sadfinder, setSadfinder] = useState({
 regDat1:''
, regDat2:''
, decRefYear1:''
, amtTbp1:''
, amtTbp2:''
, regNbr1:''
, cmpNam1:''
, decNam1:''
, expNam1:''
, colDsc:''
, trkStatus1:''
});







const location = useLocation();


useEffect(() => {
	fetchTrasheds();
	makeLsStatus();
	fetchPastmonths();
	fetchIsland();
	getusercriteria();
	openCity(null, 'tblsadfinderlight');
 },[]);


useEffect(() => {
	if (sad.INSTANCEID!=null){
		setBoolFetchingSads({flag:false}); 
		openCity(null,'tblactionsmenu')
		}
 },[sad]);






useEffect(() => {
		console.log('ctryNam.length: '+ctryNam.length);
		setSelectedCtry({NAM:'Turks and Caicos Islands'});//Turks and Caicos Islands
		document.getElementsByName('TPT_NAT_NAM')[0].value='Turks and Caicos Islands';
 },[JSON.stringify(ctryNam)]);

useEffect(() => {
		console.log('ctryCod.length: '+ctryCod.length);
		setSelectedCtry({COD:'TC'});
 },[JSON.stringify(ctryCod)]);

//emptyselectedsad=selectedsad;
//sadfinder.regDat1



  const handleFocus = (e) => {
  //e.target.blur();
  if (e.target.readOnly)
	e.target.style.background='gainsboro';
/*
else 
	e.target.select();
*/
	e.target.select();

	}//end func







function aftersendtoawc(res, args, instid, seqno){
//toggleshowtoolbar(1);
console.log('aftersendtoawc args: '+args);


/*
if (args=="op=gettransid"){
	setTranskey( {...transkey
	, "transid":res.transid
	, "instid":instid
	, "seqno":seqno
	} );
	}//end if
else 
*/

if (args=="op=new-exitnote"){
	if (res.newexitnote.result=='1'){
		//sendtoaws(args, transkey.seqno);
		fetchItemsToExit();
		}//end if
	else
		showsnackbar(res.newexitnote.message);
	}//end if
}//end func


function sendtoaws(args, seqno){

const url= awsurl + "instanceid="+sad.INSTANCEID+"&seqno="+seqno+"&"+args;

console.log('url: '+url);
fetch(url,{method: 'GET'})
.then(res => res.json() )
.then(res => aftersendtoaws(res, args, seqno) )
.catch(err => console.log(err));       
	  
}//end func


function aftersendtoaws(res, args, seqno){
console.log('aftersendtoaws args: '+args);

if (res.success=='true'){
	if (args=='op=new-exitnote'){
		console.log('next up sendtoaws op=exitgoods');
		const EXT_INSTANCE_ID=res.EXT_INSTANCE_ID;
		console.log('EXT_INSTANCE_ID:'+EXT_INSTANCE_ID);
		setSad({EXT_INSTANCE_ID:EXT_INSTANCE_ID});
		sendtoaws("op=exitgoods", seqno);
		}//end if

	if (args=='op=exitgoods'){
		alert('the new exit note was created and goods exited!');
		}//end if
		
	}//end if
else{
	alert('operation failed! please try again');
	return;
	}//end else
		
}//end func


function openSad(instanceid){
//e.preventDefault();


const state={
			sad_payment_groupid:0
			,instanceid:instanceid
			,from_sad_finder:1
			};


navigate(`/sad`,{state:state});




	}//end func




function resetFinderCriteria(){
	//var d = new Date();
	//d.setMonth(d.getMonth() - 3);
//console.log('toLocaleDateString: '+d.toLocaleDateString());
//const startdate = d.toISOString().slice(0,10);
//console.log('format: '+startdate);
//const currdate=new Date().toISOString().slice(0,10);
  const currYr=new Date().getFullYear();
setSadfinder({
regDat1: currYr+'-01-01'
, regDat2: currYr+'-12-31'
, decRefYear1: currYr
, cmpNam1:''
, expNam1:''
, decNam1:''
, regNbr1:''
, trkStatus1:''
, colDsc:'All'
});
//https://stackoverflow.com/questions/3552461/how-do-i-format-a-date-in-javascript

//d.setMonth(d.getMonth() - 3);
//console.log(d.toLocaleDateString());
}

 




function clearSearch(e){
	
	e.preventDefault();
	resetFinderCriteria();
	document.getElementsByName('regNbr1')[0].focus();
	console.log('clearSearch');
	//setSadfinder(emptySadfinder);
	

/*
	setSadfinder((prev) => {
		return {...prev 
		,regNbr1:''
		,decNam1:''
		,cmpNam1:''
		,expNam1:''
		,regDat1
		}
	});

*/
	
   

}//end func


function getusercriteria(){
	const params={
	USERNAME: sessionStorage.getItem("AW_USERNAME")
	}//end function


	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( params )
	};

	fetch(resturl+'rarsad/getusercriteria',requestOptions)
	.then(res => res.json())
	.then(res => aftergetusercriteria(res))
	.catch(err => console.log(err));
}//end func


function aftergetusercriteria(res){
	
	console.log('CRIT_VALUE: '+res[0].CRIT_VALUE);
	
	res.map((col, index)=>{
		console.log('CRIT_NAME: '+col['CRIT_VALUE']+': '+col['CRIT_NAME']);
		if (col['CRIT_NAME']=='YRMM1' && col['CRIT_VALUE']!='*') {document.getElementsByName('yrmm1')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='YRMM2' && col['CRIT_VALUE']!='*') {document.getElementsByName('yrmm2')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='ISL_COD' && col['CRIT_VALUE']!='*') {document.getElementsByName('island')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='TRK_STA' && col['CRIT_VALUE']!='*') {document.getElementsByName('trk_sta')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='IDE_REG_NBR' && col['CRIT_VALUE']!='*') {document.getElementsByName('ide_reg_nbr')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='DEC_CON_NAM' && col['CRIT_VALUE']!='*') {document.getElementsByName('dec_con_nam')[0].value=col['CRIT_VALUE'];}
		if (col['CRIT_NAME']=='TRA_SHED' && col['CRIT_VALUE']!='*') {document.getElementsByName('tra_shed')[0].value=col['CRIT_VALUE'];}
		
	});//end map
}//end func

function doSearch(e){
	e.preventDefault();
	const dec_con_nam=document.getElementsByName('dec_con_nam')[0].value;
	const yrmm1=document.getElementsByName('yrmm1')[0].value;
	const yrmm2=document.getElementsByName('yrmm2')[0].value;
	const island=document.getElementsByName('island')[0].value;
	const trk_sta=document.getElementsByName('trk_sta')[0].value;
	const ide_reg_nbr=document.getElementsByName('ide_reg_nbr')[0].value;
	const tra_shed=document.getElementsByName('tra_shed')[0].value;
	const cbcntr=(document.getElementsByName('cbcntr')[0].checked==true)?1:0;
	
	//showWaitIcon(1);
	
	if (boolFetchingSads.flag==false && (ide_reg_nbr!='' || dec_con_nam.length>2 || island!='' || trk_sta!='')){
	
	setBoolFetchingSads({flag:true});

	console.log('doSearch dec_con_nam: '+dec_con_nam);

	//const VIEW_OR_RETRIEVE=(location.state.sad_payment_groupid==0)?'V':'R';

	const params={
	USERNAME: sessionStorage.getItem("AW_USERNAME")
	, YRMM1: yrmm1
	, YRMM2: yrmm2
	, IDE_REG_NBR: ide_reg_nbr
	, DEC_CON_NAM: dec_con_nam
	, TRK_STA: trk_sta
	, ISL_COD: island
	, TRA_SHED: tra_shed
	, CNTR: cbcntr
	}//end function


	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( params )
	};

	console.log('next: call rarsad/sadfindlight');


	fetch(resturl+'rarsad/sadfindlight',requestOptions)
	.then(res => res.json())
	.then(res => aftersadfindlight(res))
	.catch(err => console.log(err));

	}//end if

}//end func


function fetchSad(instance_id){
console.log('fetchSad instance_id: '+instance_id);



const params={
INSTANCEID: instance_id
,KEY_ITM_NBR: 1
}//end function

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

setBoolFetchingSads({flag:true});

  fetch(resturl+'rarsad/getsad',requestOptions)
      .then(res => res.json())
      .then(res => frmsad(res))
      .catch(err => console.log(err));

	  

	  
}//end func 

function frmsad(res){
	var datas={};
for(var attributename in sad){
	const data=res[0][attributename];
	datas[attributename] = (data==null)?'':data;
	}//end for

setSad(datas);	
	
}//end func 


function fetchdetails(instanceId){

const params={
INSTANCEID:instanceId
, SEQNO:0
};

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};

console.log('will call getdetails: '+JSON.stringify(params));

fetch(resturl+'rarsad/getdetails',requestOptions)
  .then(res => res.json())
  .then(res => afterfetchdetails(res))
  .catch(err => console.log(err));		
	
}//end func


function afterfetchdetails(res){
let htmrows=[];
//console.log('afterfetchdetails item: '+JSON.stringify(lsitem[2]));
res.map((col, index) => {
		const key="afterfetchdetails_tr"+index;
		htmrows.push(<>
		<tr key={key} >
		<td>{col['DOC_VER']}</td>
		<td title={col['OP_NAME']} >{col['OP_NAME'].substring(0,14)}</td>
		<td>{col['FULLNAME'].substring(0,8)}</td>
		<td>{col['OP_DATE_TIME']}</td>
		</tr>
		</>
		);
		
	});//end map


//console.log('afterfetchdetails htmrows: '+JSON.stringify(htmrows));
setTbldetails(htmrows);

}//end function

function aftersadfindlight(res){
	
console.log('res.length: '+res.length);
//console.log('res[0].error: '+res[0].error);
	
setBoolFetchingSads({flag:false});

if (res.length==1 && res[0].error!=undefined){
	setTblsadfinder([]);
	return;
	}

	
let htmrows=[];
var rownum=1;
//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
res.map((col, index) => {
	const key='sadfinder'+index;
	const sadlinkid='sadlinkid'+index;
	const instanceId=col['INSTANCEID'];
		
	htmrows.push(<tr key={key} >
		<td align="left"  >
		<table align="left"  border="0"  width='100%' className='sadfinderrow' onClick={(e)=>{fetchSad(instanceId); fetchdetails(instanceId); }}  >
		<tbody>
		<tr><td  align="center" rowSpan="2" className='iconcell' ><div align="center" className='circle' style={{"backgroundColor":col['STATUS_COLOR']}} title={col['DEC_REP']} ><div align="center" className='initials'  > {col['SHORT_STATUS']}</div></div></td>
			<td  align="left" >{col['REG_NUM']}</td>
			<td  align="left" >{col['IDE_CUO_COD']}</td>
			<td  align="left" >{col['STR_AMT_DTY']}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td  align="left" >{col['PTY_COL_DSC']}</td>
			<td  align="left" >{col['STR_REG_DAT']}</td>
			<td  align="left" >{col['PTY_NBR_ITM']}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td colSpan="4" >{col['STR_CMP_NAM']+' | '+col['STR_DEC_NAM']}</td>
		</tr>
		</tbody>
		</table>
		</td>
		</tr>
	);
	rownum++;
	}//end for
	);

setTblsadfinder(htmrows);
	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


function driverChange(e){
	console.log('driverChange: '+e.target.value);
	
const jsonObj={
	SHD_COD : sad.TPT_LOC
	,TPT_NAM: document.getElementsByName('TPT_NAM')[0].value
	}
console.log('jsonObj: '+JSON.stringify(jsonObj));
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( jsonObj )
  };


  fetch(resturl+'rarsad/getexitnotedriver',requestOptions)
      .then(res => res.json())
      .then(res => aftergetexitnotedriver(res))
      .catch(err => console.log(err));	
	
}//end func



function aftergetexitnotedriver(res){
	
if (res.length==undefined)
	return;

let arrTPT_INF=[], arrTPT_IDE=[];
	
res.map((col, index) => {
		
		if (col['BAND']=='TPT_INF')
			arrTPT_INF.push(col['DRIVER_LIC_NBR']);
		else if (col['BAND']=='TPT_IDE')
			arrTPT_IDE.push(col['DRIVER_LIC_NBR']);
		
		});
	
	//console.log('arrCmp.length: '+arrTPT_INF.length);
	
    ($( "#TPT_INF" )).autoComplete({source: arrTPT_INF});   
    ($( "#TPT_IDE" )).autoComplete({source: arrTPT_IDE});   
  
  $('#TPT_INF').autoComplete('search', '');
  document.getElementsByName('TPT_INF')[0].focus();	
	
}//end func



function openCity(evt, cityName) {
	if (evt!=null)
		evt.preventDefault();

//	currCity=cityName;

console.log('openCity cityName: '+cityName);

  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  //console.log('tabcontent.length: '+tabcontent.length);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
	tablinks[i].className = tablinks[i].className.replace(" active", "");
	

	}//end for
  document.getElementById(cityName).style.display = "block";
  
 
  //evt.currentTarget.className += " active";
}//end function



function jsMenuActionOld(e, city){
e.preventDefault();
console.log('jsMenuAction city: '+city);
if (city=='tblexitnoteitems'){
	//sendtoaws(args, transkey.seqno);
	fetchItemsToExit();
	}
//openCity(null, city);
}


function showWaitIcon(flag){
	
/*
	if (flag==1){
		document.getElementById('waiticon').style.display='block';
		document.getElementById('customersContainer').style.display='none';
		
		//document.getElementById('tblsadfinder').style.display='none';
		}
	else{
		document.getElementById('waiticon').style.display='none';
		document.getElementById('customersContainer').style.display='block';
		
		//document.getElementById('tblsadfinder').style.display='block';
		}

*/	
	
}//end func  
	
function fetchTrasheds(){
console.log('fetchTrasheds ');


    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };


  fetch(resturl+'rarsad/gettrasheds',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchTrasheds(res))
      .catch(err => console.log(err));

	  
}//end func 	



function fetchIsland(){
console.log('fetchIsland ');


    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify({})
  };


  fetch(resturl+'rarsad/getisland',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchIsland(res))
      .catch(err => console.log(err));

	  
}//end func 

function afterFetchIsland(res){
	
let htmrows=[];	
	
res.map((col, index) => {
	const strISL_COD=col['ISL_COD'];
	const key='Island_'+index;
	htmrows.push(<option key={key} value={strISL_COD} >{strISL_COD}</option>);
	});//end map

setIslandOptions(htmrows);

}//end func	


function fetchPastmonths(){
console.log('fetchPastmonths ');


    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {years:3} )
  };


  fetch(resturl+'rarsad/getpastmonths',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchpastMonths(res))
      .catch(err => console.log(err));

	  
}//end func 

function afterFetchpastMonths(res){
	
let htmrows=[];	
let rowcount=1;
	
res.map((col, index) => {
	const strYRMM=col['YRMM'];
	const key='pastMonths_'+rowcount;
	htmrows.push(<option key={key} value={strYRMM} >{strYRMM}</option>);
	rowcount++;
	});//end map

setPastmonthsOptions(htmrows);

}//end func	

	
function afterFetchTrasheds(res){
	
let htmrows=[];	
	
res.map((col, index) => {
	const strLocation=col['SHD_NAM'];
	const strCod=col['SHD_COD'];
	const key='Trasheds_'+index;
	htmrows.push(<option key={key} value={strCod} >{strLocation}</option>);
	});//end map

settrashedOptions(htmrows);

}//end func	



function fetchItemsToExit(){
console.log('fetchItemsToExit ');

const args={
	INSTANCEID:sad.INSTANCEID
	, KEY_ITM_NBR:0
	};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify(args)
  };


  fetch(resturl+'rarsad/tblsaditemstoexit',requestOptions)
      .then(res => res.json())
      .then(res => afterFetchItemsToExit(res))
      .catch(err => console.log(err));

	  
}//end func 

function afterFetchItemsToExit(res){
	
let htmrows=[];	
	
res.map((col, index) => {
	const key='exititem_'+index;
	//const supQty=(col['TAR_SUP_QTY']==null)?'':col['TAR_SUP_QTY'];
	//const supCod=(col['TAR_SUP_COD']==null)?'':col['TAR_SUP_COD'];
	
	htmrows.push(
		<tr key={key} >
			<td  align="left" >{col['KEY_ITM_NBR']}</td>
			<td  align="left" ><input type='checkbox' name='cbexitnoteitems' id={key} /><label htmlFor={key} >{col['TAR_HSC_NB1']}</label></td>
			<td  align="left" >{col['VIT_WGT_GRS']}</td>
			<td  align="left" >{col['PCK_NBR']+' '+col['PCK_TYP_COD']}</td>
			<td  align="left" >{col['IDT']}<input name='CONTR_ID[]' value={col['IDT']} type='hidden' /></td>
		</tr>
	
	);
	});//end map

setExitnoteitemrows(htmrows);
openCity(null, 'tblexitnoteitems');
}//end func	


function sendtoawc(args, instanceid, seqno){
/*
valid operations are 
	gettransid
	verify
	cancel
*/	

  
console.log('sendtoawc instanceid, seqno, args: '+instanceid+', '+seqno+', '+args);
//toggleshowtoolbar(0);
//setTranskey( {...transkey, "verified":0} );
const url= awcurl + "instanceid="+instanceid+"&seqno="+seqno+"&"+args;
console.log('sendtoawc url: '+url);

fetch(url,{method: 'GET'})
.then(res => res.json() )
.then(res => aftersendtoawc(res, args, instanceid, seqno) )
.catch(err => console.log(err));       
}	//end func


function getseqno(e, instanceid, args){
e.preventDefault();
openCity(null, 'wait');
console.log('getseqno instanceid: '+instanceid);

/*const VIEW_OR_RETRIEVE=(location.state.sad_payment_groupid==0)?'V':'R';*/

const VIEW_OR_RETRIEVE='V';

const params={
username: sessionStorage.getItem("AW_USERNAME")
, SAD_PAYMENT_GROUPID: 0
, INSTANCEID: instanceid
, VIEW_OR_RETRIEVE: VIEW_OR_RETRIEVE
}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

console.log('next: call rarsad/getseqno');
//toggleshowtoolbar(0);

  fetch(resturl+'rarsad/getseqno',requestOptions)
      .then(res => res.json())
      .then(res => aftergetseqno(res, instanceid, args))
      .catch(err => console.log(err));
	  
return false;
}//end function


function aftergetseqno(res, instanceid, args){
console.log('aftergetseqno res: '+JSON.stringify(res[0]));
//toggleshowtoolbar(1);
setTranskey( {...transkey
, "seqno":res[0].SEQNO
, "LOCK_INFO":res[0].LOCK_INFO
} );

sendtoawc(args, instanceid, res[0].SEQNO);

/*
if (res[0].LOCK_INFO==null || res[0].LOCK_INFO=='' || res[0].LOCK_INFO=='null'){
	document.getElementById('btnpostentry').style.display='block';
	document.getElementById('btnverify').style.display='block';
	}//end if
else{
	document.getElementById('btnunlock').style.display='block';
	}
*/

}//end function

function jsCheckall(e, eleNam){
console.log('e.target.checked: '+e.target.checked);
var i=0, len=document.getElementsByName(eleNam).length;

for (i=0; i<len; i++){
	document.getElementsByName(eleNam)[i].checked=e.target.checked;
	}//end for
	
}//end func

function jsContinueExit(){
var i=0, len=document.getElementsByName('cbexitnoteitems').length;
var checkCount=0, cntrError='', cntrId=null;

for (i=0; i<len; i++){
	
	
	if (document.getElementsByName('cbexitnoteitems')[i].checked){
		checkCount++;
		
		const currCntrId = document.getElementsByName('CONTR_ID[]')[i].value;
		
		if (cntrId==null)
			cntrId=currCntrId;
		else{
			if (currCntrId!=cntrId)
				cntrError='you must select items with same Container-Id #';
			}//end else
		}//end if
	}//end for

if (checkCount==0)
	showsnackbar('you must select one or more items before continue');
else if (cntrError!='')
	showsnackbar(cntrError);
else{
	getexitnotehist();
	//openCity(null, 'tblexitnote');
	}
}//end func


function getexitnotehist(){

const params={
 SHD_COD: sad.TPT_LOC
}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//sendtoawc(args, instanceid, SEQNO)

  fetch(resturl+'rarsad/getcountries',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcountries(res) )
      .catch(err => console.log(err));	


  fetch(resturl+'rarsad/getexitnotehist',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetexitnotehist(res) )
      .catch(err => console.log(err));	
	
}//end func

function aftergetexitnotehist(res){
if (res.length==undefined)
	return;

let arrTPT_NAM=[], arrEXT_PLC=[];
	
res.map((col, index) => {
		
		if (col['BAND']=='TPT_NAM')
			arrTPT_NAM.push(col['DRIVER_NAME']);
		else if (col['BAND']=='EXT_PLC')
			arrEXT_PLC.push(col['DRIVER_NAME']);
		
		});
	
	//console.log('arrCmp.length: '+arrTPT_NAM.length);
	
    ($( "#TPT_NAM" )).autoComplete({source: arrTPT_NAM});   
    ($( "#EXT_PLC" )).autoComplete({source: arrEXT_PLC});   
  /*
  $('#'+elemName).autoComplete('search', '');
  */
  
openCity(null, 'tblexitnote');
  $('#TPT_NAM').autoComplete('search', '');
  document.getElementsByName('TPT_NAM')[0].focus();
}//end func

function aftergetcountries(res){
if (res.length==undefined)
	return;

let arrHiddenCtyInputs=[];
	
res.map((col, index) => {
		
		arrCTY_COD.push(<option value={col['CTY_COD']} >{col['CTY_COD']}</option>);
		arrCTY_NAM.push(<option value={col['CTY_DSC']} >{col['CTY_DSC']}</option>);
		arrHiddenCtyInputs.push(<input name='HIDDEN_CTY_COD[]' value={col['CTY_COD']} type='hidden' />);
		arrHiddenCtyInputs.push(<input name='HIDDEN_CTY_NAM[]' value={col['CTY_DSC']} type='hidden' />);
		});

//console.log('arrCTY_COD.length: '+arrCTY_COD.length);
setCtryCod(arrCTY_COD);
setCtryNam(arrCTY_NAM);

setHiddenCtyInputs(arrHiddenCtyInputs);


/*
document.getElementsByName('TPT_NAT_COD')[0].value='TC';
document.getElementsByName('TPT_NAT_NAM')[0].value='Turks and Caicos Islands';

*/

}//end func

function selectCtyCod(ctyNam){
	//setSelectedCtry({NAM:ctyNam});
	console.log('selectCtyCod ctyNam: '+ctyNam);
var i=0, len=document.getElementsByName('HIDDEN_CTY_COD[]').length;

for (i=0; i<len; i++){
	const nam=document.getElementsByName('HIDDEN_CTY_NAM[]')[i].value;
	//console.log('selectCtyCod nam: '+nam);
	if (nam==ctyNam){
		const cod = document.getElementsByName('HIDDEN_CTY_COD[]')[i].value;
		//console.log('selectCtyCod cod: '+cod);
		//document.getElementsByName('TPT_NAT_COD')[0].value=cod;
		setSelectedCtry({COD:cod});
		}//end if
		
	}//end if
	
}//end func

function sendExitNoteToDb(){
	
const EXT_PLC = document.getElementsByName('EXT_PLC')[0].value.trim();
const TPT_INF = document.getElementsByName('TPT_INF')[0].value.trim();
const TPT_NAM = document.getElementsByName('TPT_NAM')[0].value.trim();
const TPT_IDE = document.getElementsByName('TPT_IDE')[0].value.trim();

if (EXT_PLC=='' || TPT_INF=='' || TPT_NAM=='' || TPT_IDE==''){
	alert('Required inputs: place of goods exit, driver ID, driver name, vehicle license plate #');
	return;
	}//end if
	
const params={
username: sessionStorage.getItem("AW_USERNAME")
, INSTANCEID: sad.INSTANCEID
, SEQNO: transkey.seqno
, EXT_PLC: EXT_PLC
, EXT_TPT_INF: TPT_INF
, EXT_TPT_NAM: TPT_NAM
, EXT_TPT_IDE: TPT_IDE
, EXT_TPT_NAT_COD: document.getElementsByName('TPT_NAT_COD')[0].value
, EXT_TPT_NAT_NAM: document.getElementsByName('TPT_NAT_NAM')[0].value
, EXT_INSTANCE_ID: sad.EXT_INSTANCE_ID
}//end function

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

//sendtoawc(args, instanceid, SEQNO)

  fetch(resturl+'rarsad/sendExitNoteToDb',requestOptions)
      .then(res => res.json())
      .then(res => 	sendtoaws("op=new-exitnote", transkey.seqno) )
      .catch(err => console.log(err));
}//end func

/*
EXT_PLC
EXT_TPT_INF
EXT_TPT_NAM
EXT_TPT_IDE
EXT_TPT_NAT_COD
EXT_TPT_NAT_NAM
*/

function alterit(val){
	console.log('alterit '+val);
}
function makeLsStatus(){
const arrStatus='Stored,Registered,Assessed,Paid,Exited,Cancelled'.split(',');
let htmrows=[];
for (var i=0; i<arrStatus.length; i++){
	const strStatus=arrStatus[i];
	const key='brk_sta_'+i;
	htmrows.push(<option key={key} value={strStatus} >{strStatus}</option>);
	}//end for

setStatusOptions(htmrows);

}//end func  


  return (
    <>
<div className="respLpanel">&nbsp;</div>

<div className="respMpanel">

<div id="tblsadfinderlight" align="center" className="tabcontent" >  

    <table align='center' border='0' cellPadding='0' cellSpacing='0'  className="tblsadfinderlight" >
	<tbody>

	{/*
	<tr>
		<td align="center" >&nbsp;</td>
		<td align="center" >from</td>
		<td align="center" >to</td>
	</tr>	
	*/}
	<tr>

		<td align='left' >
		<select name='island'  >
		<option value='' >***island***</option>
		{islandOptions}
		</select>
		</td>
	</tr>

	<tr>
		<td align='left' >
		<select name='yrmm1'  >
		{pastmonthsOptions}
		</select>
		</td>
	</tr>
	<tr>
		
		<td align='left'>
		<select name='yrmm2'   >
		{pastmonthsOptions}
		</select>
		</td>
	</tr>
	<tr>
			
		<td align='left' >
		<select name='trk_sta'>
		<option value='' >***status***</option>
		{statusOptions}
		</select>
		&nbsp;&nbsp;
		<input type='checkbox' id='cbcntr' name='cbcntr' title='container' /><label htmlFor='cbcntr' >Cntr</label>
		</td>
	</tr>
	<tr>

		<td align='left'  >
		<select name='tra_shed'>
		<option value='' >***shed***</option>
		{trashedOptions}
		</select>		</td>

	
	
	</tr>
	
	<tr>
	<td align='left' >
		<input name='dec_con_nam' placeholder='broker/importer code/name' size='22'  onFocus={(e)=>{e.target.select();}} autoComplete='off' />
	</td>
	</tr>
	<tr>
		{/* style={{"fontSize":"11px"}} <input name='ast_ryr' size='4' defaultValue='2017' placeholder='year' autoComplete='off' onFocus={(e)=>{e.target.select();}} autoComplete='off' />*/}

		

		<td align='left' >
		<input name='ide_reg_nbr' size='8' placeholder='E#' autoComplete='off' defaultValue='' onFocus={(e)=>{e.target.select();}} autoComplete='off'  />
		&nbsp;&nbsp;
		{boolFetchingSads.flag ==false && <a href='#' onClick={(e)=>{doSearch(e);}} ><img src='img/Search_Icon.gif' border='0' /></a>}
		</td>
	</tr>
	
	
	</tbody>
	</table>
	{/* 1519 adrian */}

      {boolFetchingSads.flag ==false &&
		<table border="0" align='center' cellPadding='0' cellSpacing='0'  >
		{/*
			<thead>
			<th align="left" >
			reg number &nbsp; office &nbsp; date &nbsp; <br/>importer &nbsp;declarant &nbsp;
			</th>
			</thead>
		
		*/}
			<tbody>
			{tblsadfinder}
			</tbody>
		</table>
      }

      {boolFetchingSads.flag ==true &&   <div align='center' ><img src='img/ajax_loader.gif' height='42' border='0' /> . . . please wait</div>  }
</div>	  



<div id="wait" align="center" className="tabcontent" >  
<img src='img/ajax_loader.gif' border='0' height='42' /> . . . please wait
</div>

<div id="tblexitnoteitems" align="center" className="tabcontent" >  
		<div align='center' >
		
		<a href='#' onClick={(e)=>{openCity(e, 'tblsadfinderlight');}} ><img src='img/return.png' border='0' /></a>
		&nbsp;&nbsp;&nbsp;&nbsp;
		<button className='button' onClick={(e)=>{jsContinueExit(e);}}  >continue exit note</button>
		</div>
		<table align="left"  border="1"  width='100%' className='tblexitnoteitems'     >
		<thead>
		<tr>
			<th  align="left" >#</th>
			<th  align="center" ><input type='checkbox' id='cbcheckall' onClick={(e)=>{jsCheckall(e,'cbexitnoteitems');}} /><label htmlFor='cbcheckall' >Tariff</label></th>
			<th  align="left" >Lbs</th>
			<th  align="left" >Packg</th>
			<th  align="left" >Contr</th>
		</tr>
		</thead>
		<tbody>
		{exitnoteitemrows}
		</tbody>
		</table>
</div>

<div id="tblactionsmenu" align="center" className="tabcontent" >  
<table align='center'>
<tbody>
<tr>
<td align='center'>
		<table align="left"  border="0"  width='100%' className='sadfinderrow'   >
		<tbody>
		<tr><td  align="center" rowSpan="2" className='iconcell' ><div align="center" className='circle' style={{"backgroundColor":sad.STATUS_COLOR}} title={sad.DEC_REP} ><div align="center" className='initials'  > {sad.SHORT_STATUS}</div></div></td>
			<td  align="left" >{sad.STR_REG_NBR}</td>
			<td  align="left" >{sad.IDE_CUO_COD}</td>
			<td  align="left" >{sad.STR_AMT_DTY}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td  align="left" >{sad.PTY_COL_DSC}</td>
			<td  align="left" >{sad.STR_REG_DAT}</td>
			<td  align="left" >{sad.PTY_NBR_ITM}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td colSpan="4" align='center'  >{sad.STR_CMP_NAM+' | '+sad.STR_DEC_NAM}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td colSpan="4" align='center' >{sad.STR_SHD_NAM}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td colSpan="4" align='center'  >Containers:{sad.CTR_COUNT}</td>
		</tr>
		<tr className='sadfinderrownames' >
			<td colSpan="4" align='center'  >Account:{sad.FIN_ACC}</td>
		</tr>
		</tbody>
		</table>
</td>
</tr>
{/*<tr><td align='left' className='operMenu' ><img src='img/Btn_Open_Normal.gif' border='0' /> Retrieve</td></tr>*/}
{/*<tr><td align='left' className='operMenu' ><img src='img/Btn_Clear.gif' border='0' /> Clear Declaration</td></tr>*/}
<tr><td align='left' className='operMenu' ><a href='#' className='nodecor' onClick={(e)=>{getseqno(e, sad.INSTANCEID, 'op=new-exitnote');}} ><img src='img/Icon_NCTS.gif' border='0' /> Create Exit Note</a></td></tr>
<tr><td align='left' className='operMenu' ><a href='#' className='nodecor' onClick={(e)=>{openCity(e, 'tblsadfinderlight');}} ><img src='img/return.png' border='0' /> Return</a></td></tr>
<tr>
	<td>
		<div align='left'>Details of SAD Operations</div>
		<table align="left" border="1"  style={{"borderCollapse":"collapse"}} cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Operation</th>
		<th>User</th>
		<th>Time</th>
		</tr>		
		</thead>
		<tbody>
		{tbldetails}
		</tbody>
		</table>
	</td>
</tr>
</tbody>
</table>
</div>	  

<div id="tblexitnote" align="center" className="tabcontent" >  
<table align='center'>
<tbody>
<tr><td align='left'>Customs Office<br/><input value={sad.STR_OFFICE} readOnly className='grey' /></td></tr>
<tr><td align='left'>Customs Registration #<br/><input value={sad.STR_REG_NBR} readOnly className='grey'  /></td></tr>
<tr><td align='left'>Location<br/><input value={sad.STR_SHD_NAM}  readOnly className='grey' /></td></tr>
<tr><td align='left'>Declarant<br/><input value={sad.STR_DEC_NAM} readOnly className='grey'  /></td></tr>


<tr><td align='left'>Place of exit of goods<br/><input  name='EXT_PLC' id='EXT_PLC'  onFocus={(e)=>{e.target.select();}} autoComplete='off'   /></td></tr>
<tr><td align='left'>driver&apos;s name<br/><input name='TPT_NAM' id='TPT_NAM' onBlur={(e)=>{driverChange(e);}}  onFocus={(e)=>{e.target.select();}} autoComplete='off'  /></td></tr>
<tr><td align='left'>driver&apos;s identification #<br/><input name='TPT_INF' id='TPT_INF' onFocus={(e)=>{e.target.select();}}  autoComplete='off'  /></td></tr>
<tr><td align='left'>vehicle license plate #<br/><input  name='TPT_IDE' id='TPT_IDE' onFocus={(e)=>{e.target.select();}}   /></td></tr>

<tr><td align='left'>vehicle license plate country<br/>
		<table align='left'>
		<tbody>
		<tr>
		<td align='left'><select name='TPT_NAT_COD' value={selectedCtry.COD} disabled >{ctryCod}</select></td>
		</tr>
		<tr>
		<td align='left'><select name='TPT_NAT_NAM' value={selectedCtry.NAM} onChange={(e)=>{setSelectedCtry({NAM:e.target.value});selectCtyCod(e.target.value)}}  >{ctryNam}</select></td>
		</tr>
		</tbody>
		</table>
	</td></tr>
<tr><td align='left' style={{"paddingTop":"6px"}}>
	<a href='#' ><img src='img/return.png' onClick={(e)=>{openCity(e, 'tblsadfinderlight');}} border='0' title='return' /></a>
	&nbsp;&nbsp;&nbsp;
	<input type='button' className='button' value='create exit note' onClick={(e)=>{ sendExitNoteToDb(); }} />
	</td>
</tr>

</tbody>
</table>
</div>	  

<div id='snackbar' ></div>
</div>
<div className="respRpanel" >&nbsp;</div>
{hiddenCtyInputs}
    </>
  );
  


};


export default RenderSadfinderLight;